export default function videoPlayer() {
    $(document).ready(function() {
        const videoPlayer = '.video-player';

        if ($(videoPlayer).length > 0) {
            setTimeout(function () {
                var players = Plyr.setup(videoPlayer, {
                    hideControls: (!/iPad|iPhone|iPod|Android/.test(navigator.userAgent)),
                    controls: ['play-large', 'play', 'mute', 'progress', 'current-time', 'muted', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
                    fullscreen: {enabled: true, fallback: false, iosNative: true}
                });
            }, 1000);

        }
    });

}
